const React = require('react');
const StatusScreenBrickEs = require('./statuscreenES');
const StatusScreenBrickPt = require('./statuscreenPT');
const StatusScreenBrickREEs = require('./statuscreenREES');
const StatusScreenBrickREPt = require('./statuscreenREPT');

const StatusScreen = {
  es: StatusScreenBrickEs,
  pt: StatusScreenBrickPt,
  en: StatusScreenBrickEs,
  're-pt': StatusScreenBrickREPt,
  're-es': StatusScreenBrickREEs,
  're-en': StatusScreenBrickREEs,
};
module.exports = StatusScreen;
